import React, { useState } from 'react';
import UserService from '../../services/userService';
import AuthHeader from '../AuthHeader';
import Footer from '../Footer';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleEmailChange = (event) => {
    event.preventDefault();
    setEmail(event.target.value);
  };

  const handleForgotClick = async (event) => {
    event.preventDefault();
    
    if (!email) {
      setError('Please enter your email address');
      return;
    }

    setSending(true);
    setError('');
    try {
      await UserService.forgot({
        username: email
      });

      setSending(false);
      setSent(true);
    } catch (error) {
      setSending(false);
      setError(error ? error.message : 'Unexpected error');
    }
  };

  const renderError = () => {
    if (error) {
      return (
        <div className="alert mt-3 mb-3 alert-danger" role="alert">{error}</div>
      );
    }

    if (sent) {
      return (
        <div className="alert mt-3 mb-3 alert-success" role="alert">If a matching account was found an email was sent to {email} to allow you to reset your password.</div>
      );
    }

    return null;
  };

  return (
    <div className="auth-page-container">
      <div className="auth-content">
        <div className="container">
          <AuthHeader />
          <div className="auth-form-container">
            <form className="form-signin">
              <h1 className="h3 mb-3 font-weight-normal text-center">Reset your password</h1>

              <div className="form-box">
                <div className="form-group">
                  <label htmlFor="inputEmail">Email address</label>
                  <input
                    type="email"
                    required=""
                    className="form-control"
                    id="inputEmail"
                    value={email}
                    onChange={handleEmailChange}
                  />
                </div>

                <button onClick={handleForgotClick} className="btn btn-bs btn-primary" type="submit">Send password reset email</button>
                {renderError()}
              </div>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default ForgotPassword;
